
/*
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @interface PropertiesAPI
 * @hideconstructor
 * @classdesc API class that is used to obtain the list of properties and property layouts, and manage provider registrations.
 * @example dashboard.getFeature('Properties')
 */
define([], () => {
	class PropertiesAPI {

		/**
		 * @function PropertiesAPI#getPropertyLayoutList
		 * @description Returns the list of all property layouts.
		 * @return {Object[]}
		 */
		getPropertyLayoutList() {}

		/**
		 * @function PropertiesAPI#getPropertyList
		 * @description Returns the list of all properties.
		 * @return {Object[]}
		 */
		getPropertyList() {}

		/**
		 * @function PropertiesAPI#registerProvider
		 * @description Registers a provider as a properties provider.
		 * @param {PropertiesProviderAPI} provider Properties provider to register and contribute properties
		 */
		registerProvider() {}

		/**
		 * @function PropertiesAPI#deregisterProvider
		 * @description Deregisters a provider as a properties provider.
		 * @param {PropertiesProviderAPI} provider Properties provider to deregister and remove properties
		 */
		deregisterProvider() {}

		/**
		 * for debug usage
		 */
		getProviderPropertyNameList() {}
	}

	return PropertiesAPI;
});
